<button class="btn btn-submenu-color btn-sm" routerLinkActive="btn-submenu-active-color"
  routerLink="/admin/portal-configuration/portal-parameters">
  {{ 'PORTAL_PARAMETERS' | translate }}
</button>

<button class="btn btn-submenu-color btn-sm" routerLinkActive="btn-submenu-active-color"
  routerLink="/admin/portal-configuration/faqs">
  {{ 'FAQS' | translate }}
</button>